import { Logger } from '@codeleap/common'
import { Settings } from './Settings'

export const logger = new Logger(Settings)

// @ts-ignore
global.logger = logger
